import {Injectable} from '@angular/core';
import {UsageOccupant} from '../../pages/rt2012/parametrage-usages/models/UsageOccupant';
import {ReleveIndividuel} from '../../models/rt2012/ReleveIndividuel';
import {Deserialize} from 'cerialize';
import {environment} from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Logement} from '../../models/logement';

@Injectable({
  providedIn: 'root'
})
export class UsageOccupantService {
  baseApiUrl: string = environment.api.baseUrl;

  constructor(private http: HttpClient) {
  }

  save(usageOccupant: UsageOccupant, logement: Logement): Promise<UsageOccupant> {
    return this.http.post(`${this.baseApiUrl}rt2012/usages-occupant/update/${logement.id}`, usageOccupant).toPromise().then(
      (rawReleve) => {
        return Deserialize(rawReleve, UsageOccupant);
      }, (data) => {
        if (data.status === 400) {
          return data.error;
        }
        throw new Error(`An unexpected error occurred while data loading ${JSON.stringify(data)}`);
      });
  }

}
